import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const AnalyticsTypeOfIncomeExpenseItemList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.AnalyticsTypeOfIncomeExpenseItem} />
        </>
    );
}

export default AnalyticsTypeOfIncomeExpenseItemList;